//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: ['categories', 'states', 'brands', 'models', 'cities', 'fuels', 'page', 'query', 'vehicles'],
    data(){
        return {
            filters:{},
            showFiltersModal: false,
            openingFiltersModal: false,
            showOrderByModal: false,
            openingOrderByModal: false
        }
    },
    methods:{
        closeFilterModal(){
            if(this.openingFiltersModal){
                this.showFiltersModal=false
            }
        },
        closeOrderByModal(){
            if(this.openingOrderByModal){
                this.showOrderByModal=false
            }
        },
    },
    watch:{
        $route(){
            document.getElementById('filters').scrollTop = 0;
        },
        showFiltersModal(n,o){
            if(n&&!o){
                setTimeout(()=>{
                    this.openingFiltersModal=true
                },100)
            }else{
                this.openingFiltersModal=false
            }
        },
        showOrderByModal(n,o){
            if(n&&!o){
                setTimeout(()=>{
                    this.openingOrderByModal=true
                },100)
            }else{
                this.openingOrderByModal=false
            }
        },
    },
}
